export default __webpack_public_path__ + "static/media/Icon_SingleSelectTextChoice.9e2c3ae8.svg";